module.exports = __webpack_public_path__ + "static/media/stock_out.3313e406.svg";